import{defineMessages}from'react-intl';

export default defineMessages({
label_quarter:{
id:'i18n.stock_lift_list.label_quarter',
defaultMessage:'Quarter'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9TdG9ja0xpZnRMYW5kaW5nUGFnZS9TdG9ja0xpZnRTdW1tYXJ5L1N0b2NrTGlmdExpc3QvU3RvY2tMaWZ0TGlzdC5tZXNzYWdlcy5qcyJdLCJuYW1lcyI6WyJkZWZpbmVNZXNzYWdlcyIsImxhYmVsX3F1YXJ0ZXIiLCJpZCIsImRlZmF1bHRNZXNzYWdlIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFTQSxjQUFULEtBQStCLFlBQS9COztBQUVBLGNBQWVBLGdCQUFlO0FBQzVCQyxjQUFlO0FBQ2JDLEdBQUksb0NBRFM7QUFFYkMsZUFBZ0IsU0FGSCxDQURhLENBQWYsQ0FBZiIsImZpbGUiOiJTdG9ja0xpZnRMaXN0Lm1lc3NhZ2VzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBkZWZpbmVNZXNzYWdlcyB9IGZyb20gJ3JlYWN0LWludGwnO1xuXG5leHBvcnQgZGVmYXVsdCBkZWZpbmVNZXNzYWdlcyh7XG4gIGxhYmVsX3F1YXJ0ZXI6IHtcbiAgICBpZDogJ2kxOG4uc3RvY2tfbGlmdF9saXN0LmxhYmVsX3F1YXJ0ZXInLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnUXVhcnRlcicsXG4gIH0sXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/pages/StockLiftLandingPage/StockLiftSummary/StockLiftList/StockLiftList.messages.js
// module id = 2324
// module chunks = 0